module.exports = __webpack_public_path__ + "img/bg-depoimentos.d2244ea1.png";